<div class="item-inner">
  <div class="item-header text-4">
    {{ orderOnboardingView.companyName }}
  </div>
  <div class="item-content">
    @for (order of orderOnboardingView.orders; track order) {
      <div>
        <div class="content-header text-bold-2 row">
          <div class="days col-6">
            <span>{{ order.approvedDate | customDate: 'daysDifferAbs' }}</span>
            <span class="text-bold-4"> {{ ((order.approvedDate | customDate: 'daysDifferAbs') == '1' ? 'general.day' : 'general.days') | translate }}</span>
          </div>
          <div class="date text-bold-4 col-6">
            <div>{{ order.approvedDate | customDate: 'shortDate' }}</div>
          </div>
        </div>
        <div class="products text-5">
          @for (product of order.products; track product) {
            <div class="status-indicator row no-gutters" [ngClass]="getOnboardingStatusStyle(product)">
              <span class="product col">{{ product.name }}</span>
              <span class="price col">{{ product.productValue | currency }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="item-footer text-2">
    {{ getTotalValue() | currency }}
  </div>
</div>